import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { usePermission } from "src/app/hooks/permissions/use-permission";

interface KaribuUtilityRedirectProps {
  children: React.ReactNode;
}

/**
 * This component checks if the user has ONLY the Karibu Utility permission.
 * If so, it redirects them to the Karibu Utility page instead of the default landing page.
 */
const KaribuUtilityRedirect: React.FC<KaribuUtilityRedirectProps> = ({
  children,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { hasOnlyKaribuUtilityAccess, userPermissions } = usePermission();

  useEffect(() => {
    // Only redirect if user permissions have been loaded

    // If user has ONLY Karibu Utility access and is on landing page, redirect to Karibu Utility
    if (
      hasOnlyKaribuUtilityAccess &&
      (location.pathname === "/landing" ||
        location.pathname === "/" ||
        location.pathname === "")
      ) {
      navigate("/karibu-utility", { replace: true });
    }
  }, [
    hasOnlyKaribuUtilityAccess,
    userPermissions,
    location.pathname,
    navigate,
  ]);

  return <>{children}</>;
};

export default KaribuUtilityRedirect;
